module.exports = __webpack_public_path__ + "static/img/11.3c921d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/11.jpg
// module id = cytV
// module chunks = 5